export default __webpack_public_path__ + "static/media/io.21130dd4.svg";